import { render, staticRenderFns } from "./EditMediaCoverage.vue?vue&type=template&id=225b39bd&"
import script from "./EditMediaCoverage.vue?vue&type=script&lang=js&"
export * from "./EditMediaCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports